import React from 'react'
import { ICalendarPickerDispatch, ICalendarPickerProps } from './CalendarPicker'

function withRefButton(
  C: React.ComponentType<ICalendarPickerProps & ICalendarPickerDispatch>,
) {
  return class WithRefButton extends React.Component<
    ICalendarPickerProps & ICalendarPickerDispatch
  > {
    private readonly buttonRef: React.RefObject<HTMLAnchorElement> | null = null

    public constructor(props) {
      super(props)
      this.buttonRef = React.createRef()
    }

    public render() {
      return <C {...this.props} anchor={this.buttonRef} />
    }
  }
}

export default withRefButton
